module.exports = __webpack_public_path__ + "static/12_Facebook-f9f4abbbd32a1ef01f330ecd0c353a30.png";